import { Platform } from 'react-native'
import Constants from 'expo-constants'

const {
  nativeAppVersion,
  nativeBuildVersion,
  manifest: { version, extra },
} = Constants

/**
 * Returns the full app version
 * @returns {string} The version
 */
export const getVersion = (): string =>
  Platform.OS === 'web'
    ? `${version}.${extra?.webBuildNumber}`
    : `${nativeAppVersion}.${nativeBuildVersion}`

export const getTokenExpiryDate = (expiresInMs: number): string => new Date(new Date().getTime() + expiresInMs).toISOString()

export const getAssetUrl = (id: string) => `${process.env.DIRECTUS_API_URL}/assets/${id}`